import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { translate } from "react-i18next";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import MenuItem from "@material-ui/core/MenuItem";

import settings from "./settings";
import InputFormat from "../inputForm";
import DistrictVietnam from "./dist/quan_huyen.json";
import WardVietnam from "./dist/xa_phuong.json";

class WardDropdown extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      wards: []
    };
    this.getWards = this.getWards.bind(this);
  }

  componentDidMount() {
    let regionCode = this.getRegionCode(this.props.region);
    this.setState({ wards: this.getWards(regionCode) });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.region !== this.props.region) {
      let regionCode = this.getRegionCode(nextProps.region);
      this.setState({ wards: this.getWards(regionCode) });
    }
  }

  getWards(region) {
    const { country } = this.props;

    if (!region || country !== "VN") {
      return [];
    } else {
      let wards = [];
      wards = Object.values(WardVietnam).filter(
        item => item.parent_code === region
      );
      if (wards.length === 0) {
        return [];
      } else {
        return wards;
      }
    }
  }

  getRegionCode = regionValue => {
    // Get region code of region value
    let res = Object.values(DistrictVietnam).find(e => e.name === regionValue);

    if (res) return res.code;
    return null;
  };

  getWardList() {
    let { wards = [] } = this.state;
    return wards.map((ward, i) => {
      return (
        <MenuItem key={i} value={ward.name}>
          {ward.name}
        </MenuItem>
      );
    });
  }

  // there are two default options. The "blank" option which shows up when the user hasn't selected a country yet, and
  // a "default" option which shows
  getDefaultOption() {
    const {
      blankOptionLabel,
      showDefaultOption,
      defaultOptionLabel,
      placeholder,
      country,
      region
    } = this.props;
    if (!country && !region) {
      return (
        <MenuItem key="default" value=" ">
          {blankOptionLabel}
        </MenuItem>
      );
    }
    if (showDefaultOption) {
      return (
        <MenuItem key="default" value=" ">
          {defaultOptionLabel || placeholder}
        </MenuItem>
      );
    }
    return null;
  }

  render() {
    const {
      t,
      label,
      value,
      onChange,
      onBlur,
      id,
      name,
      disabled,
      classes,
      disable,
      InputLabelProps = {},
      SelectProps = {},
      ...arbitraryProps
    } = this.props;

    const attrs = {
      ...arbitraryProps,
      name,
      label,
      value,
      onChange: e => onChange(e),
      onBlur: e => onBlur(e),
      disabled: disabled
    };
    if (id) {
      attrs.id = id;
    }
    if (classes) {
      attrs.className = classes;
    }

    return (
      <InputFormat
        {...attrs}
        select
        SelectProps={{
          displayEmpty: true,
          ...SelectProps
        }}
        InputLabelProps={{
          ...InputLabelProps
        }}
      >
        {this.getDefaultOption()}
        {this.getWardList()}
      </InputFormat>
    );
  }
}

const styles = theme => ({
  title: {
    fontSize: "1.5rem"
  },
  textField: {
    marginRight: theme.spacing(1),
    width: "100%"
  },
  input: {},
  label: {
    fontWeight: 410
  }
});

WardDropdown.propTypes = {
  country: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  id: PropTypes.string,
  classes: PropTypes.object,
  blankOptionLabel: PropTypes.string,
  showDefaultOption: PropTypes.bool,
  defaultOptionLabel: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  labelType: PropTypes.string,
  valueType: PropTypes.string,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  disableUnderline: PropTypes.bool,
  customOptions: PropTypes.array
};
WardDropdown.defaultProps = {
  country: "",
  value: "",
  name: "rcrs-region",
  id: "",
  classes: {},
  blankOptionLabel: "-",
  showDefaultOption: true,
  defaultOptionLabel: "Select District",
  onChange: () => { },
  onBlur: () => { },
  countryValueType: settings.DISPLAY_TYPE_FULL,
  regionvaluetype: settings.DISPLAY_TYPE_FULL, // warning react : regionValueType => regionvaluetype
  labelType: settings.DISPLAY_TYPE_FULL,
  valueType: settings.DISPLAY_TYPE_FULL,
  disabled: false,
  customOptions: []
};

const mapState = state => ({});

const mapDispatch = dispatch => ({});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(WardDropdown)
  )
);
